import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { FireAndFlowerSaleCardStackBackgroundViewModel } from './fire-and-flower-sale-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-fire-and-flower-sale-card-stack-background',
  templateUrl: './fire-and-flower-sale-card-stack-background.component.html',
  styleUrls: ['./fire-and-flower-sale-card-stack-background.component.scss'],
  providers: [FireAndFlowerSaleCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerSaleCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: FireAndFlowerSaleCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
